// auth0Client.js
let auth0Api = null;
console.log("auth0Api ",auth0Api)
export const setAuth0Client = (client) => {
  auth0Api = client;
};

export const auth0Client = {
  getAccessTokenSilently: (...args) => auth0Api?.getAccessTokenSilently(...args),
  logout: (...args) => auth0Api?.logout(...args),
};
